import { Arrangement } from '#~/video/index.js';

/** Toggle titles. */
export const Titles = Object.freeze({
  [Arrangement.Single]: 'Single-Camera',
  [Arrangement.Multiple]: 'Multi-Camera'
} satisfies Record<Arrangement, string>);
